import types from './types';
import API from '../../lib/api';
import {toast} from 'react-toastify';
import globalTypes from '../types';
import ModalsLib from '../../lib/modals';

export const loadNotifications = () => async dispatch => {
    const response = await API.call({
        path: '/notifications/list'
    });

    if(response.success) {
        dispatch({
            type: types.loaded,
            payload: response.data
        });
    } else {
        dispatch({
            type: types.loaded,
            payload: {
                notifications: [],
                has_unread: false,
                notifications_count: 0
            }
        });
    }
}

export const toggleNotifications = state => async dispatch => {
    if(!state) {
        const response = await API.call({
            path: '/notifications/widget-open'
        });    

        if(response.success)
            dispatch({
                type: types.mark_as_read,
                payload: response.notifications
            });
    }
    
    return dispatch({
        type: types.toggle
    });
}

export const redeemFreeplayBonus = (id, game) => async dispatch => {
    dispatch({
        type: types.toggle_notification,
        payload: id
    });

    const response = await API.call({
        path: '/notifications/offers/freeplay',
        body: {
            id,
            game
        }
    });

    dispatch({
        type: types.toggle_notification,
        payload: id
    });

    if(response.success) {
        toast.dismiss();
        toast.success(response.message);

        dispatch({
            type: globalTypes.games.history.add,
            payload: response.transaction
        });
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}

export const redeemBoostBonus = (id) => async dispatch => {
    dispatch({
        type: types.toggle_notification,
        payload: id
    });

    const response = await API.call({
        path: '/notifications/offers/boost',
        body: {
            id
        }
    });

    dispatch({
        type: types.toggle_notification,
        payload: id
    });

    if(response.success) {
        toast.dismiss();
        toast.success(response.message);

        dispatch({
            type: globalTypes.user.deposit_bonus,
            payload: response.deposit_bonus
        });

        ModalsLib.open('wallet');
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}